module.exports = __webpack_public_path__ + "static/media/iten-logo.8c90a5b5.svg";